"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const SearchWidget_1 = require("../widgets/SearchWidget");
const HtmlWidget_1 = require("../widgets/HtmlWidget");
const InstagramWidget_1 = require("../widgets/InstagramWidget");
const CategoriesWidget_1 = require("../widgets/CategoriesWidget");
const TagsWidget_1 = require("../widgets/TagsWidget");
class WidgetArea extends React.Component {
    render() {
        const props = this.props;
        return (React.createElement("div", null, this.props.widgets ?
            this.props.widgets.filter((widget) => {
                return widget.areaName === props.name;
            }).sort((widget1, widget2) => {
                return widget1.order - widget2.order;
            })
                .map((widget) => {
                if (widget.widgetType === 'search') {
                    return (React.createElement(SearchWidget_1.default, { key: widget.name, data: widget.data }));
                }
                if (widget.widgetType === 'html') {
                    return (React.createElement(HtmlWidget_1.default, { key: widget.name, data: widget.data, html: widget.html }));
                }
                if (widget.widgetType === 'instagram' && widget.data.queryData.length > 0) {
                    return (React.createElement(InstagramWidget_1.default, { key: widget.name, data: widget.data }));
                }
                if (widget.widgetType === 'categories') {
                    return (React.createElement(CategoriesWidget_1.default, { key: widget.name, data: widget.data }));
                }
                if (widget.widgetType === 'tags') {
                    return (React.createElement(TagsWidget_1.default, { key: widget.name, data: widget.data }));
                }
            }) : null));
    }
}
class WidgetAreaProps {
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(WidgetArea, ['ApplicationStore'], (context, props) => {
    const result = {
        widgets: context.getStore('ApplicationStore').getWidgets(),
    };
    return result;
});
